import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { Box, Tooltip, IconButton, } from '@mui/material';
import { HelpOutlineOutlined } from '@mui/icons-material'


interface CenteredTabsProps {
  value: string
  handleChange: (event: React.SyntheticEvent, newValue: string) => void
  isGrantDateValid: boolean | '' | undefined | null
}

export default function CenteredTabs({
  value,
  handleChange,
  isGrantDateValid,
}: CenteredTabsProps) {
  return (
    <Tabs
      value={value}
      onChange={handleChange}
      sx={{
        marginBottom: 2,
        '& .MuiTabs-indicator': {
          backgroundColor: '#9135E0', // Purple indicator
        },
        '& .MuiTabs-flexContainer': {
          display: 'flex',  
          alignItems: 'center',     
          gap: '14px',          
        },
        '& .MuiTab-root': {
          // Default tab style
          color: '#6B7280',
          fontSize: {xs: '15px', sm: '20px'},
          fontWeight: 500,
          padding: '12px 12px',
          fontFamily: 'InterMedium',
          '&.Mui-selected': {
            // Selected tab style
            color: '#9135E0', // Purple text for selected tab
            fontWeight: 500,
          },
        },
      }}>
      <Tab label="Removal Stats" value={'Removal Stats'} />
      {isGrantDateValid && (
      <Tab 
        value={'Opt Out Requests'} 
        className="opt-out-requests-tab"
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <span>Opt Out Requests</span>
            <Tooltip
              title="Not all data brokers publicly list the data they sell. While we can remove your data from these companies,
              we cannot verify the removal due to a lack of public profiles"
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    fontFamily: 'InterRegular',
                    fontSize: '10px',
                    lineHeight: '16px',
                    fontWeight: 500,
                    color: '#ffffff',
                  },
                },
              }}
            >
            <IconButton>
              <HelpOutlineOutlined
                sx={{
                  position: 'absolute', 
                  fontSize: '18px',
                  color: 'rgba(145, 53, 224, 1)',
                  left: '45%',
                  top: '-1px',
                }}
              />
            </IconButton>
            </Tooltip>
          </Box>
        }  
        />
      )}
              
    </Tabs>
  )
}
